import Api from '@services/api';
import { SyncResult } from '../containers/integration-settings/types';

export const INTEGRATION_FUNCTIONS_REQUEST =
  'admin/INTEGRATION_FUNCTIONS_REQUEST';
export const INTEGRATION_FUNCTIONS_SUCCESS =
  'admin/INTEGRATION_FUNCTIONS_SUCCESS';
export const INTEGRATION_FUNCTIONS_FAILURE =
  'admin/INTEGRATION_FUNCTIONS_FAILURE';
export const INTEGRATION_FUNCTIONS_UPDATE =
  'admin/INTEGRATION_FUNCTIONS_UPDATE';

export const INTEGRATION_SYNC_REQUEST = 'admin/INTEGRATION_SYNC_REQUEST';
export const INTEGRATION_SYNC_SUCCESS = 'admin/INTEGRATION_SYNC_SUCCESS';
export const INTEGRATION_SYNC_FAILURE = 'admin/INTEGRATION_SYNC_FAILURE';

export const IMPORT_FUNCTION_REQUEST = 'admin/IMPORT_FUNCTION_REQUEST';
export const IMPORT_FUNCTION_SUCCESS = 'admin/IMPORT_FUNCTION_SUCCESS';
export const IMPORT_FUNCTION_FAILURE = 'admin/IMPORT_FUNCTION_FAILURE';

export const IMPORT_FUNCTIONS_BULK_REQUEST =
  'admin/IMPORT_FUNCTIONS_BULK_REQUEST';
export const IMPORT_FUNCTIONS_BULK_SUCCESS =
  'admin/IMPORT_FUNCTIONS_BULK_SUCCESS';
export const IMPORT_FUNCTIONS_BULK_FAILURE =
  'admin/IMPORT_FUNCTIONS_BULK_FAILURE';

export const UPDATE_FUNCTION_INTEGRATION_REQUEST = 'admin/UPDATE_FUNCTION_INTEGRATION_REQUEST';
export const UPDATE_FUNCTION_INTEGRATION_SUCCESS = 'admin/UPDATE_FUNCTION_INTEGRATION_SUCCESS';
export const UPDATE_FUNCTION_INTEGRATION_FAILURE = 'admin/UPDATE_FUNCTION_INTEGRATION_FAILURE';

export const UPDATE_FUNCTION_BY_ID_REQUEST = 'admin/UPDATE_FUNCTION_BY_ID_REQUEST';
export const UPDATE_FUNCTION_BY_ID_SUCCESS = 'admin/UPDATE_FUNCTION_BY_ID_SUCCESS';
export const UPDATE_FUNCTION_BY_ID_FAILURE = 'admin/UPDATE_FUNCTION_BY_ID_FAILURE';

export type IntegrationFunction = {
  type: 'function';
  id: string;
  organisationId: string;
  name: string;
  externalId: string[];
  createdAt: string;
};

export type FunctionGroup = {
  externalId: string;
  name: string;
  linked_with: IntegrationFunction[];
};

export const fetchIntegrationFunctions =
  (organisationId: string) => async (dispatch: any) => {
    dispatch({ type: INTEGRATION_FUNCTIONS_REQUEST });

    try {
      const response = await Api.get(
        `/v1/organisations/${organisationId}/integration/functions`
      );

      dispatch({
        type: INTEGRATION_FUNCTIONS_SUCCESS,
        data: response.data,
      });

      return response.data;
    } catch (error: any) {
      dispatch({
        type: INTEGRATION_FUNCTIONS_FAILURE,
        error: error.message,
      });
      return Promise.reject(error);
    }
  };

export const syncIntegration =
  (
    organisationId: string,
    drySync: boolean = true,
    skipUserInvite: boolean = true
  ) => async (dispatch: any): Promise<SyncResult> => {
    dispatch({ type: INTEGRATION_SYNC_REQUEST });

    try {
      const response = await Api.post(
        `/v1/organisations/${organisationId}/integration/sync`,
        {
          drySync,
          firstSync: false,
          skipUserInvite,
          disableSafetyThreshold: false,
        }
      );

      dispatch({ type: INTEGRATION_SYNC_SUCCESS, data: response as SyncResult });
      return response as SyncResult;
    } catch (error: any) {
      dispatch({ type: INTEGRATION_SYNC_FAILURE, error: error.message });
      throw error;
    }
  };

export const importFunction =
  (
    organisationId: string,
    functionData: { name: string; externalId: string[] }
  ) => async (dispatch: any) => {
    dispatch({ type: IMPORT_FUNCTION_REQUEST });

    const response = await Api.post(
      `/v2/organisations/${organisationId}/functions`,
      functionData
    );

    dispatch({
      type: IMPORT_FUNCTION_SUCCESS,
      data: response.data,
    });

    await dispatch(fetchIntegrationFunctions(organisationId));
  };

export const importFunctionsBulk =
  (
    organisationId: string,
    functionsData: Array<{ name: string; externalId: string[] }>
  ) => async (dispatch: any) => {
    dispatch({ type: IMPORT_FUNCTIONS_BULK_REQUEST });

    const response = await Api.post(
      `/v2/organisations/${organisationId}/functions`,
      functionsData as any
    );

    dispatch({
      type: IMPORT_FUNCTIONS_BULK_SUCCESS,
      data: response.data,
    });

    await dispatch(fetchIntegrationFunctions(organisationId));
  };

export const updateFunctionById =
  (
    organisationId: string,
    functionId: string,
    functionData: { externalId: string[], name?: string }
  ) => async (dispatch: any) => {
    dispatch({ type: UPDATE_FUNCTION_BY_ID_REQUEST });

    try {
      const response = await Api.put(
        `/v2/organisations/${organisationId}/functions/${functionId}`,
        functionData
      );

      dispatch({
        type: UPDATE_FUNCTION_BY_ID_SUCCESS,
        data: response.data,
      });
    } catch (error: any) {
      dispatch({
        type: UPDATE_FUNCTION_BY_ID_FAILURE,
        error: error.message
      });
      throw error;
    }
  };
